import React, { useEffect } from "react";
import {
  useHistory,
  useParams,
  useLocation
} from "react-router-dom/cjs/react-router-dom.min";
import api from "../utils/axiosApi";
import queryString from "query-string";
import LoadingCurtain from "../components/LoadingCurtain";
import { Toast } from "../utils/sweetalert";
import withReactContent from "sweetalert2-react-content";
import Routes from "../utils/Routes";

function ProcessPaymentPage() {
  const params = useParams();
  const location = useLocation();

  const history = useHistory();

  const handleValidateModelCalendar = async (payment) =>{
    const { data: clonedCalendar, error } = await api.post(
      `/ModelsCalendar/clone/${payment.data.resource_id}`,
      {
        payment_id: payment.data._id,
      }
    );
    if (error) throw new Error(error);
    history.push(
      Routes.agencyCalendar(
        clonedCalendar.data.agency.urlId,
        clonedCalendar.data._id
      )
    );
  }

  const handleValidateAgency = async (payment) =>{
    const { data: clonedCalendar, error } = await api.patch(
      `/agencias/unlock-functionalities/`,
      {
        payment_id: payment.data._id,
      }
    );
    if (error) throw new Error(error);
    history.push(
      Routes.Bussiness()
    );
  }

  useEffect(() => {
    const processPayment = async () => {
      
      //preguntar por el recurso externo
      try {
        const values = queryString.parse(location.search);
        if (values.rejected) 
          throw new Error("El pago fue rechazado");
        debugger
        const { data: payment } = await api.patch(
          `/payments/${params.idPayment}`,
          {
            external_id: values.payment_id,
          }
        );
        
        if (payment.data.type === "model_itinerary") {
          handleValidateModelCalendar(payment)
        }
        else if (payment.data.type === "agency_unlock") {
          handleValidateAgency(payment)
        }
      } catch (error) {
        const msg = error.response?.data?.error?.detail || error.message;
        const MyToast = withReactContent(Toast)
        await MyToast.fire({
            title: <p style={{fontSize: '15px', zIndex: 30000}}>{msg}</p>,
            icon: 'error',
            })
            api.patch(
              `/payments/${params.idPayment}`,
              {
                status: "rejected",}
            );
            history.push(
              "/"
            );
      }
    };

    processPayment();
    return () => {};
  }, []);

  return <div><LoadingCurtain
  zIndex={60}
  background={"rgba(255, 255, 255, 0.507)"}
  isLoading={true}
/></div>;
}

export default ProcessPaymentPage;
